import { emitUIEvent, getIdFromHTMLEvent } from '@montugroup/data-collection';
import { GlobalBehaviourProvider } from '@montugroup/design-system';
import { useCallback } from 'react';

export const SnowplowUIIntegration = (props: React.PropsWithChildren) => {
  const handler = useCallback((componentName: string, eventName: string, details: string, e: React.SyntheticEvent) => {
    //TODO: Source contexts for Snowplow (feature flags, etc)
    let id = getIdFromHTMLEvent(e) ?? '';

    //TODO: Temp fix. We'll need a better mechanism in the long term for connect a component's root to the interactive elements in it.
    if (!id && componentName === 'Checkbox') {
      const parentDiv = e.currentTarget.parentElement;
      id = parentDiv?.getAttribute('data-tracking-id') ?? parentDiv?.getAttribute('id') ?? '';
    }

    emitUIEvent(
      {
        component_name: componentName,
        event_name: eventName,
        id,
        value: details,
      },
      [],
    );
  }, []);

  return <GlobalBehaviourProvider handler={handler}>{props.children}</GlobalBehaviourProvider>;
};
